<ng-template #template let-anchor>
    <span>{{ anchor.nativeElement.value ? anchor.nativeElement.value : 'clear' }}</span>
</ng-template>
<kendo-combobox *ngIf="!isMultiSelect"
    kendoTooltip
    (mouseover)="showTooltip($event)"
    [tooltipTemplate]="template"
    [data]="data$ | async"
    [disabled]="baseControlledDisabledState"
    [loading]="isLoading"
    [kendoDropDownFilter]="filterSettings"
    [allowCustom]="(!enableCache && !data$) || allowCustom" 
    [textField]="textField"
    [valueField]="valueField"
    [valuePrimitive]="valuePrimitive"
    [placeholder]="placeholder"
    [filterable]="true" 
    (filterChange)="debounceTrigger.execute($event)"
    [ngModel]="value"
    (ngModelChange)="changeValue($event)"
    [class.small-dropdown]="smallView">
    <ng-template kendoGridCellTemplate let-dataItem>
        <span kendoTooltip title="{{dataItem}}">
        </span>
    </ng-template>
    <ng-template kendoDropDownListNoDataTemplate>
        <h4>
            {{noDataFoundText}}
        </h4>
    </ng-template>
</kendo-combobox>

<kendo-multiselect *ngIf="isMultiSelect && !multiSelectSettings?.isGridFilter"
    kendoTooltip
    (mouseover)="showTooltip($event)"
    [tooltipTemplate]="template"
    [data]="data$ | async"
    [disabled]="baseControlledDisabledState"
    [loading]="isLoading"
    [kendoDropDownFilter]="filterSettings"
    [allowCustom]="(!enableCache && !data$) || allowCustom" 
    [textField]="textField"
    [valueField]="valueField"
    [valuePrimitive]="valuePrimitive"
    [placeholder]="placeholder"
    [filterable]="true" 
    (filterChange)="debounceTrigger.execute($event)"
    [ngModel]="value"
    (ngModelChange)="changeValue($event)"
    [itemDisabled]="itemDisabled.bind(this)">
    <ng-template kendoDropDownListNoDataTemplate>
        <h4>
            {{noDataFoundText}}
        </h4>
    </ng-template>
</kendo-multiselect>

<kendo-multiselect *ngIf="isMultiSelect && multiSelectSettings?.isGridFilter"
    kendoTooltip
    (mouseover)="showTooltip($event)"
    [tooltipTemplate]="template"
    [data]="data$ | async"
    [disabled]="baseControlledDisabledState"
    [loading]="isLoading"
    [kendoDropDownFilter]="filterSettings"
    [allowCustom]="(!enableCache && !data$) || allowCustom" 
    [textField]="textField"
    [valueField]="valueField"
    [valuePrimitive]="valuePrimitive"
    [placeholder]="placeholder"
    [filterable]="true" 
    (filterChange)="debounceTrigger.execute($event)"
    [ngModel]="value"
    (ngModelChange)="changeValue($event)"
    [itemDisabled]="itemDisabled.bind(this)"
    [clearButton]="false"
    kendoMultiSelectSummaryTag>
    <ng-template kendoMultiSelectGroupTagTemplate let-dataItems>
        {{ dataItems.length }} item(s)
    </ng-template>
    <ng-template kendoDropDownListNoDataTemplate>
        <h4>
            {{noDataFoundText}}
        </h4>
    </ng-template>
    <span class="k-icon k-i-arrow-s" ng-reflect-ng-class="k-i-arrow-s"></span>
</kendo-multiselect>